import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledQuotaText = styled.span`
  display: flex;
  gap: 4px;
`;

export const StyledMainText = styled.span`
  ${setFontVariant('listItem3', colorsPalettes.carbon[500])};
`;
